(function ($) {
    $.fn.notification = function (options) {
        return this.each(function () {
            const self = $(this);
            // Default settings
            var settings = $.extend({
                ctaClose: self.find( '[data-tab-close]' )
            }, options );
            if( self.data( 'notification' ) !== 'active' ) {
                self.data( 'notification', 'active' );

                let notificationTimeout;

                function closeFavoriteNotification() {
					notificationTimeout	= setTimeout(function(){
                        settings.ctaClose.click();
                        self.data( 'notification', null );
                    }, 2000);
                }

                closeFavoriteNotification();

                self.on('focusin.notification mouseenter.notification', function(){
                    clearTimeout( notificationTimeout );
                }).on('focusout.notification mouseleave.notification', closeFavoriteNotification );
            }
        });
    }
})(jQuery);
